import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import "../../../Styles/EmployeeWorking.css";
import axios from "axios";
import {
  fetchemployeewrkhrs,
  updateStateOfEmployeeHours,
} from "../../../Redux/features/Reports/EmployeeWorkinghrs/EmployeeWorkinghrsSlice";
import { useAuthDetails } from "../../../Common/cookiesHelper";

import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Grid } from "@mui/material";
import { priceFormate } from "../../../hooks/priceFormate";
import PasswordShow from "../../../Common/passwordShow";
import { SkeletonTable } from "../../../reuseableComponents/SkeletonTable";
import Skeleton from "react-loading-skeleton";
import NoDataFound from "../../../reuseableComponents/NoDataFound";
import useDelayedNodata from "../../../hooks/useDelayedNoData";
import { formatDateOnly } from "../../../Constants/utils";
import { updateReportPayload } from "../../../Redux/features/Reports/SalesReport/SalesReportSlice";
import { BASE_URL, GET_BREAK_SETTING } from "../../../Constants/Config";
import { ToastifyAlert } from "../../../CommonComponents/ToastifyAlert";

const StyledTable = styled(Table)(({ theme }) => ({
  padding: 2, // Adjust padding as needed
}));
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--qv-bg-253338, #253338)",
    color: theme.palette.common.white,
    fontFamily: "CircularSTDMedium !important",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: "CircularSTDBook",
  },
  [`&.${tableCellClasses.table}`]: {
    fontSize: 14,
    fontFamily: "CircularSTDBook",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    // backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {},
  "& td, & th": {
    // border: "none",
    borderBottom: "1px solid #E8E8E8",
  },
}));

const tableRow = [
  "Work Date",
  "Time In",
  "Time Out",
  "Total Hours",
  "Break Hours",
  "Hours Worked",
];
const getVisibleTableColumns = (showBreakHours) =>
  showBreakHours
    ? tableRow
    : tableRow.filter((column) => column !== "Break Hours");

const Employeedetails = (props) => {
  const { LoginGetDashBoardRecordJson, LoginAllStore, userTypeData } =
    useAuthDetails();
  const {
    handleCoockieExpire,
    getUnAutherisedTokenMessage,
    getNetworkError,
    ZoneWiseDate,
  } = PasswordShow();
  const dispatch = useDispatch();
  const [allEmpWorkingHrsData, setallEmpWorkingHrsData] = useState("");
  const [breakTrackingEnabled, setBreakTrackingEnabled] = useState(null);
  const [breakSettingLoading, setBreakSettingLoading] = useState(true);
  const showNoData = useDelayedNodata(Object.keys(allEmpWorkingHrsData));
  const AllEmpWorkingHrsDataState = useSelector(
    (state) => state.EmpWorkinghrsList
  );

  let AuthDecryptDataDashBoardJSONFormat = LoginGetDashBoardRecordJson;
  let merchant_id = AuthDecryptDataDashBoardJSONFormat?.data?.merchant_id;
  const showBreakHours = breakTrackingEnabled === "1";
  const visibleTableColumns = getVisibleTableColumns(showBreakHours);

  useEffect(() => {
    if (props.selectedEmployeeList.length === 0) {
      dispatch(updateStateOfEmployeeHours());
      return;
    }
    getEmployeewrkhrs();
  }, [props.selectedDateRange, props.selectedEmployeeList]);

  useEffect(() => {
    getBreakSetting();
  }, [merchant_id, userTypeData?.token, userTypeData?.token_id, userTypeData?.login_type]);

  const getEmployeewrkhrs = async () => {
    try {
      if (props && props.selectedDateRange) {
        let data = {
          merchant_id,
          start_date: props.selectedDateRange.start_date,
          end_date: props.selectedDateRange.end_date,
          // employee_id: props.EmpId,
          employee_id:
            Array.isArray(props.selectedEmployeeList) &&
            props.selectedEmployeeList.length > 0 &&
            !props.allEmployeeSelected
              ? props.selectedEmployeeList.map((emp) => emp.id).join(",")
              : "All",
          ...userTypeData,
        };
        if (data) {
          dispatch(updateReportPayload(data));
          await dispatch(fetchemployeewrkhrs(data)).unwrap();
        }
      }
    } catch (error) {
      if (error?.status == 401 || error?.response?.status === 401) {
        getUnAutherisedTokenMessage();
        handleCoockieExpire();
      } else if (error?.status == "Network Error") {
        getNetworkError();
      } else {
        ToastifyAlert(error?.message || error?.payload || "Something went wrong. Please try again.", "error");
      }
    }
  };

  const getBreakSetting = async () => {
    if (!merchant_id) {
      setBreakTrackingEnabled("0");
      setBreakSettingLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("merchant_id", merchant_id);
    formData.append("token_id", userTypeData.token_id);
    formData.append("login_type", userTypeData.login_type);

    try {
      setBreakSettingLoading(true);
      const response = await axios.post(BASE_URL + GET_BREAK_SETTING, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userTypeData?.token}`,
        },
      });

      if (response.data?.status === true) {
        setBreakTrackingEnabled(
          String(response.data?.data?.[0]?.enable_break_tracking ?? "0")
        );
      } else {
        setBreakTrackingEnabled("0");
      }
    } catch (error) {
      setBreakTrackingEnabled("0");
      if (error?.status == 401 || error?.response?.status === 401) {
        getUnAutherisedTokenMessage();
        handleCoockieExpire();
      } else if (error?.status == "Network Error") {
        getNetworkError();
      } else {
        ToastifyAlert(error?.message || error?.payload || "Something went wrong. Please try again.", "error");
      }
    } finally {
      setBreakSettingLoading(false);
    }
  };

  useEffect(() => {
    if (
      breakTrackingEnabled !== null &&
      !AllEmpWorkingHrsDataState.loading &&
      AllEmpWorkingHrsDataState?.employeewrkhrstData
    ) {
      props.setCSVFileName("employee_time_and_attendance_report");
      const csvHeaders = [
        { label: "Employee Name", key: "employee_name" },
        { label: "Work Date", key: "work_date" },
        { label: "Time In", key: "first_check_in_time" },
        { label: "Time Out", key: "last_check_out_time" },
        { label: "Total Hours", key: "total_seconds_worked" },
        { label: "Hours Worked", key: "effective_seconds_worked" },
      ];
      if (showBreakHours) {
        csvHeaders.splice(5, 0, {
          label: "Break Hours",
          key: "total_seconds_break",
        });
      }
      props.setCSVHeader(csvHeaders);

      const csvData = [];

      const employees = Object.keys(
        AllEmpWorkingHrsDataState?.employeewrkhrstData
      );
      employees.forEach((employee) => {
        const employeeData =
          AllEmpWorkingHrsDataState?.employeewrkhrstData[employee];

        // now loop over all the employeeData...
        employeeData.forEach((row) => {
          const obj = {
            employee_name: employee,
            work_date: formatDateOnly(row.work_date, "-"),
            first_check_in_time: row.first_check_in_time,
            last_check_out_time: row.last_check_out_time,
            total_seconds_worked: priceFormate(
              (
                parseFloat(convertSecondsToHours(row.total_seconds_worked)) || 0
              ).toFixed(2)
            ),
            effective_seconds_worked: priceFormate(
              (
                parseFloat(
                  convertSecondsToHours(row.effective_seconds_worked)
                ) || 0
              ).toFixed(2)
            ),
          };
          if (showBreakHours) {
            obj.total_seconds_break = priceFormate(
              (
                parseFloat(convertSecondsToHours(row.total_seconds_break)) || 0
              ).toFixed(2)
            );
          }

          csvData.push(obj);
        });

        // and then add a total row...
        const totalRow = {
          employee_name: "",
          work_date: "",
          first_check_in_time: "",
          last_check_out_time: "Total",
          total_seconds_worked: priceFormate(
            calTotalWork(employeeData).toFixed(2)
          ),
          effective_seconds_worked: priceFormate(
            parseFloat(calTotalActualWork(employeeData)).toFixed(2)
          ),
        };
        if (showBreakHours) {
          totalRow.total_seconds_break = priceFormate(
            parseFloat(calTotalBreak(employeeData)).toFixed(2)
          );
        }

        csvData.push(totalRow);
      });

      // console.log("csvData: ", csvData);

      props.setCSVData(csvData);
      setallEmpWorkingHrsData(AllEmpWorkingHrsDataState.employeewrkhrstData);
    } else {
      props.setCSVHeader([]);
      props.setCSVFileName("");
      props.setCSVData([]);
      setallEmpWorkingHrsData("");
    }
  }, [
    breakTrackingEnabled,
    showBreakHours,
    AllEmpWorkingHrsDataState,
    AllEmpWorkingHrsDataState.loading,
    AllEmpWorkingHrsDataState.ItemSalesData,
  ]);

  const convertSecondsToHours = (seconds) => {
    const hours = seconds / 3600;
    return hours;
  };

  const calTotalWork = (totalworkdata) => {
    if (!Array.isArray(totalworkdata)) {
      return 0;
    }
    return totalworkdata.reduce((total, workData) => {
      const parsedSeconds = parseFloat(workData.total_seconds_worked);
      const validSeconds = isNaN(parsedSeconds) ? 0 : parsedSeconds;
      const totalNew = total + convertSecondsToHours(validSeconds);

      return totalNew;
    }, 0);
  };

  const calTotalBreak = (totalbreakdata) => {
    if (!Array.isArray(totalbreakdata)) {
      return 0;
    }
    return totalbreakdata.reduce(
      (total, workData) =>
        total +
        convertSecondsToHours(parseFloat(workData.total_seconds_break ?? 0)),
      0
    );
  };
  const calTotalActualWork = (totalactualworkdata) => {
    if (!Array.isArray(totalactualworkdata)) {
      return 0;
    }

    return totalactualworkdata.reduce((total, workData) => {
      const parsedSeconds = parseFloat(workData.effective_seconds_worked);
      const validSeconds = isNaN(parsedSeconds) ? 0 : parsedSeconds;
      return total + convertSecondsToHours(validSeconds);
    }, 0); // Initial value of the accumulator is 0
  };

  // useEffect(() => {
  //   console.log("allEmpWorkingHrsData: ", allEmpWorkingHrsData);
  // }, [allEmpWorkingHrsData]);

  return (
    <>
      <div className="box">
        {AllEmpWorkingHrsDataState.loading || breakSettingLoading ? (
          <>
            <Grid container className="box_shadow_div">
              <Grid item xs={12}>
                <div className="q-attributes-bottom-header">
                  <span>
                    <Skeleton />
                  </span>
                </div>
              </Grid>
              <SkeletonTable columns={visibleTableColumns} />
            </Grid>
          </>
        ) : (
          <>
            {allEmpWorkingHrsData &&
              Object.keys(allEmpWorkingHrsData).map((employeeName, index) => (
                <>
                  <Grid container className="box_shadow_div">
                    <Grid item xs={12}>
                      <Grid
                        sx={{ mx: { xs: 2, md: "unset" } }}
                        className="q-attributes-bottom-header"
                      >
                        <span>{employeeName}</span>
                      </Grid>
                      <TableContainer>
                        <StyledTable
                          sx={{ minWidth: 500 }}
                          aria-label="customized table"
                        >
                          <TableHead>
                            {visibleTableColumns.map((row) => (
                              <StyledTableCell key={row}>{row}</StyledTableCell>
                            ))}
                          </TableHead>
                          <TableBody>
                            {Array.isArray(
                              allEmpWorkingHrsData[employeeName]
                            ) &&
                              allEmpWorkingHrsData[employeeName].length &&
                              allEmpWorkingHrsData[employeeName].map(
                                (workData, dataIndex) => (
                                  <>
                                    <StyledTableRow>
                                      <StyledTableCell>
                                        <p>
                                          {formatDateOnly(
                                            workData?.work_date,
                                            "-"
                                          )}
                                        </p>
                                      </StyledTableCell>
                                      <StyledTableCell>
                                        <p>{workData.first_check_in_time}</p>
                                      </StyledTableCell>
                                      <StyledTableCell>
                                        <p>{workData.last_check_out_time}</p>
                                      </StyledTableCell>
                                      <StyledTableCell>
                                        <p>
                                          {priceFormate(
                                            (
                                              parseFloat(
                                                convertSecondsToHours(
                                                  workData.total_seconds_worked
                                                )
                                              ) || 0
                                            ).toFixed(2)
                                          )}
                                        </p>
                                      </StyledTableCell>
                                      {showBreakHours && (
                                        <StyledTableCell>
                                          <p>
                                            {priceFormate(
                                              (
                                                parseFloat(
                                                  convertSecondsToHours(
                                                    workData.total_seconds_break
                                                  )
                                                ) || 0
                                              ).toFixed(2)
                                            )}
                                          </p>
                                        </StyledTableCell>
                                      )}
                                      <StyledTableCell>
                                        <p>
                                          {priceFormate(
                                            (
                                              parseFloat(
                                                convertSecondsToHours(
                                                  workData.effective_seconds_worked
                                                )
                                              ) || 0
                                            ).toFixed(2)
                                          )}
                                        </p>
                                      </StyledTableCell>
                                    </StyledTableRow>
                                  </>
                                )
                              )}
                            {Array.isArray(
                              allEmpWorkingHrsData[employeeName]
                            ) && (
                              <StyledTableRow className="trBG_Color">
                                <StyledTableCell></StyledTableCell>
                                <StyledTableCell></StyledTableCell>
                                <StyledTableCell>
                                  <p className=" totalReport">Total</p>
                                </StyledTableCell>
                                <StyledTableCell>
                                  <p className=" totalReport">
                                    {priceFormate(
                                      calTotalWork(
                                        allEmpWorkingHrsData[employeeName]
                                      ).toFixed(2)
                                    )}
                                  </p>
                                </StyledTableCell>
                                {showBreakHours && (
                                  <StyledTableCell>
                                    <p className=" totalReport">
                                      {priceFormate(
                                        parseFloat(
                                          calTotalBreak(
                                            allEmpWorkingHrsData[employeeName]
                                          )
                                        ).toFixed(2)
                                      )}
                                    </p>
                                  </StyledTableCell>
                                )}
                                <StyledTableCell>
                                  <p className=" totalReport">
                                    {priceFormate(
                                      parseFloat(
                                        calTotalActualWork(
                                          allEmpWorkingHrsData[employeeName]
                                        )
                                      ).toFixed(2)
                                    )}
                                  </p>
                                </StyledTableCell>
                              </StyledTableRow>
                            )}
                            {!Array.isArray(
                              allEmpWorkingHrsData[employeeName]
                            ) && (
                              <Grid container sx={{ padding: 2.5 }}>
                                <Grid item xs={12}>
                                  <p>No. Data found.</p>
                                </Grid>
                              </Grid>
                            )}
                          </TableBody>
                        </StyledTable>
                      </TableContainer>
                    </Grid>
                  </Grid>
                </>
              ))}
          </>
        )}
      </div>
      <Grid sx={{ mt: 3.5 }}>
        {showNoData &&
          !Object.keys(allEmpWorkingHrsData).length &&
          !AllEmpWorkingHrsDataState.loading &&
          !breakSettingLoading && (
            <Grid container className="box_shadow_div">
              <Grid item xs={12}>
                <div className="q-attributes-bottom-header">
                  <span>
                    <Skeleton />
                  </span>
                </div>
              </Grid>
              <TableContainer className="relative">
                <StyledTable
                  sx={{ minWidth: 500 }}
                  aria-label="customized table"
                >
                  <TableHead>
                    {visibleTableColumns.map((row) => (
                      <StyledTableCell key={row}>{row}</StyledTableCell>
                    ))}
                  </TableHead>
                  <TableBody>
                    <div style={{ height: "180px" }}></div>
                    <div
                      style={{
                        width: "15rem",
                        position: "-webkit-absolute",
                        position: "absolute",
                        top: "80px",
                        left: "0",
                        right: "0",
                        margin: "0 auto",
                      }}
                    >
                      <NoDataFound table={true} />
                    </div>
                  </TableBody>
                </StyledTable>
              </TableContainer>
            </Grid>
          )}
      </Grid>
    </>
  );
};

export default Employeedetails;
